import React from 'react'

import { Container, Row, Col, Image } from 'react-bootstrap'

import Styles from './EarnedShirtScreen.module.scss'

const EarnedShirtScreen = () => {
  return (
    <Container fluid className={Styles.gradient}>
      <Row>
        <Col>
          <div className={Styles.shirt}>
            <Row>
              <Col
                md={{ span: 12, order: 1 }}
                xs={{ span: 12, order: 2 }}
                className={Styles.left}
              >
                <h2>Prizes</h2>
                <b>1st Place:</b>
                <ul className={Styles.prizeList}>
                  <li>EVO Fre rope from RX Smart Gear</li>
                  <li>$50 NOBULL Gift Card</li>
                  <li>1 year of ROMWOD</li>
                  <li>14oz PRVN Logo YETI Mug</li>
                </ul>

                <b>2nd Place:</b>
                <p className={Styles.marginBottom}>50% off EVO Fre Rx Smart Gear rope</p>

                <b>3rd Place:</b>
                <p className={Styles.marginBottom}>25% off EVO Fre Rx Smart Gear rope</p>

                <p>$500 1st Phorm gift card to a randomly selected registrant</p>
              </Col>

              {/*<Col
                md={{ span: 6, order: 2 }}
                xs={{ span: 12, order: 1 }}
                className={Styles.right}
              >
                <h2>Workout Levels</h2>
                <div className={Styles.tshirt}></div>

                <h3 className={Styles.light}>Which Shirt Will You Earn?</h3>
                <h3>Rx’d</h3>
                <ul className={Styles.list}>
                  <li>Level 1: --</li>
                  <li>Level 2: Complete the workout Rx’d</li>
                  <li>Level 3: Complete the workout in 5:00 min or less</li>
                  <li>Level 4: Complete the workout in 3:00 min or less</li>
                </ul>

                <h3>Scaled</h3>
                <ul className={Styles.list}>
                  <li>Level 1: Complete the scaled version of the workout</li>
                </ul>

                <h3>Masters 35+</h3>
                <ul className={Styles.list}>
                  <li>Level 1: --</li>
                  <li>Level 2: Complete the workout Rx’d</li>
                  <li>Level 3: Complete the workout in 5:00 min or less</li>
                  <li>Level 4: Complete the workout in 3:00 min or less</li>
                </ul>

                <h3>Masters 35+ Scaled</h3>
                <ul className={Styles.list}>
                  <li>Level 1: Complete the scaled version of the workout</li>
                </ul>

                <div className={Styles.pdfs}>
                  <p><a href="https://s3.amazonaws.com/media.btwb.co/Earned+Series/fran_rules.pdf">Rules Guide PDF</a></p>
                  <p><a href="https://s3.amazonaws.com/media.btwb.co/Earned+Series/fran_lessonplan.pdf">Gym Lesson Plan PDF</a></p>
                </div>
              </Col>*/}
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default EarnedShirtScreen
